<template>
	<div class="simulationsPage">
		<div class="simulationsPage__excludesFooter">
			<div>
				<BHeader />
			</div>

			<SimulationsNoneFound v-if="!simulations.length" />

			<SimulationsSearch v-else />
		</div>
		<BFooter />
	</div>
</template>

<script>
import { mapState } from "vuex";

import BFooter from "@/components/base/BFooter.vue";
import BHeader from "@/components/base/BHeader.vue";

import BBtn from "@/components/base/BBtn";

import SimulationsNoneFound from "./SimulationsNoneFound.vue";
import SimulationsSearch from "./SimulationsSearch.vue";

export default {
	components: {
		SimulationsNoneFound,
		SimulationsSearch,
		BFooter,
		BHeader,
		BBtn,
	},
	computed: {
		...mapState("simulations", ["simulations"]),
		simulations() {
			return [1, 2, 3];
		},
	},
};
</script>

<style lang="scss">
.simulationsPage {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	min-height: 100vh;
}

.simulationsPage__excludesFooter {
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	align-items: stretch;
}
</style>
